module.exports = __webpack_public_path__ + "img/17.bddbc86e.png";